import { render } from "./OperationsLinksPage.vue?vue&type=template&id=3c63b1da"
import script from "./OperationsLinksPage.vue?vue&type=script&lang=js"
export * from "./OperationsLinksPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__